/*global require: false */
require(['jquery',
    'validate',
    'unobtrusive',
    'validateAll',
    'mvcFoolProofValidate'],

    function ($) {
        'use strict';

        $('#AccountNumberLinks').change(function () {
            if ($('#AccountNumberLinks').val() == 'Provider Tax Identification Number') {
                //make dupe PTIN visible, required and set value
                $('#dupTIN').removeClass('hide');
                var value = $('#IdentificationNumber').val();
                $('#DupeIdentificationNumber').val(value);
                 //hide dupNPI and clear value
                $('#dupNPI').addClass('hide');
                $('#DupeNationalProviderIdentifier').val('');
            }
            else {
                if ($('#AccountNumberLinks').val() == 'National Provider Identification Number') {
                    //make dupNPI visible, required, and set value
                    $("#dupNPI").removeClass('hide');
                    var value = $('#NationalProviderIdentifier').val();
                    $('#DupeNationalProviderIdentifier').val(value);
                    // hide dupPTIN and clear value
                    $('#dupTIN').addClass('hide');
                    $('#DupeIdentificationNumber').val('');
                }
            }
        });


        $('#SelectedSupportDocumentType').change(function () {
            if ($('#AccountNumberLinks').val() != 'Select') {
                $('#browseFile').removeClass('hide');
            }
            else
            {
                
                $('#browseFile').addClass('hide');
                
             }
        });
    });
define("eft-form", function(){});

